<template>
  <div class="cont_main">
    <span class=" font-bold text-xl">SU PEDIDO</span>
    <div class="absolute right-10 top-2 w-10 cursor-pointer" @click="toggleShowShopping()">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        width="100%"
        viewBox="0 0 50 50"
        style=" fill:#000000;"
      >
      <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 32.990234 15.986328 A 1.0001 1.0001 0 0 0 32.292969 16.292969 L 25 23.585938 L 17.707031 16.292969 A 1.0001 1.0001 0 0 0 16.990234 15.990234 A 1.0001 1.0001 0 0 0 16.292969 17.707031 L 23.585938 25 L 16.292969 32.292969 A 1.0001 1.0001 0 1 0 17.707031 33.707031 L 25 26.414062 L 32.292969 33.707031 A 1.0001 1.0001 0 1 0 33.707031 32.292969 L 26.414062 25 L 33.707031 17.707031 A 1.0001 1.0001 0 0 0 32.990234 15.986328 z"></path>
      </svg>
    </div>
    <div class="list_prods">
      <div class="cont_vacio" v-if="productosShopping.length == 0">
        <label>Agregue Productos Para Realizar Su Compra</label>
      </div>
      <div class="cont_prod grid grid-cols-3" v-else v-for="(prod, index) in productosFinal" :key="index">
        <div><label class=" font-bold">{{"Pag.: "}}</label>{{ " " + prod.numPagina }} </div>
        <div><label class=" font-bold">{{"Ref.: "}}</label>{{ " " + prod.referenciaOriginal }} </div>
        <div><label class=" font-bold">{{"Cod.: "}}</label>{{ " " + prod.numCodigo }} </div>
        <div class="col-span-2 mt-2">{{ prod.strNombre }} </div>
        <div class="mt-2"><label class=" font-bold">{{"Cantidad: "}}</label>{{ " " + cantidad(prod) }} </div>
        <div class="mt-2"><label class=" font-bold">{{"Precio Prod.: "}}</label>{{ Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(prod.precioCatalogo) }} </div>
        <div class="mt-2"><label class=" font-bold">{{"Total Prod.: "}}</label>{{ Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(prod.precioCatalogo * cantidad(prod)) }} </div>
        <div class=" cont_btn grid grid-cols-3">
          <div class="sumar_cant" @click="setProductoShopping(prod)" v-if="cantidad(prod) < 9">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" x="0px" y="0px"
              width="24" height="24" fill="#fff">
              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"/>
            </svg>
          </div>
          <div class="restar_cant" @click="restaCantidad(prod)" v-if="cantidad(prod) > 1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" x="0px" y="0px"
              width="24" height="24" fill="#fff">
              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path d="M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"/>
            </svg>
          </div>
          <div class="eliminar_prod" @click="deleteProductoShopping(prod)">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="24" height="24"
              viewBox="0 0 24 24"
              style=" fill:#fff;">
              <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="cont_total grid grid-cols-2" v-if="productosShopping.length !== 0">
      <div class=" text-left font-bold text-lg inline-table">Total (IVA incl.) : </div> <div class="text-center font-bold text-lg inline-table">{{ Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(totalPedido) }}</div>
    </div>
    <div class="cont_btnWhatsapp text-white cursor-pointer" @click="enviarWhatsapp()" v-if="productosShopping.length !== 0">
      <div class="cont_logoWhatsapp inline-table w-1/4 h-full cursor-pointer scale-150">
        <svg xmlns="http://www.w3.org/2000/svg" class="my-auto w-full"
        width="24" height="24"
        viewBox="0 0 24 24"
        style=" fill:#fff;">   
          <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"></path>
        </svg>
      </div>
      <div class="cont_label_Whatsapp text-left font-bold text-lg inline-table my-auto w-3/4 cursor-pointer">
        <label class="relative -top-1 cursor-pointer">Enviar Pedido Via Whatsapp</label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {

    };
  },
  methods: {
    ...mapMutations(["deleteProductoShopping","toggleShowShopping","setProductoShopping","restaCantidad"]),

    cantidad(producto){
      var cant = this.productosShopping.filter((x) => x.numCodigo == producto.numCodigo)

      return cant.length
    },

    enviarWhatsapp(){
      //enviar evento al pulsar boton Whatsapp
      gtag('event', 'BtnWhatsapp', {
        'Whatsapp': '1'
      });

      let prods = 'Los productos de mi pedido de Campaña ' + this.campaña.substring(4,6) + ' son: '
      for (let i = 0; i < this.productosFinal.length; i++) {
        prods = prods + '\n                                                                 ' +
                        '\n                                                                  / Codigo.: ' + this.productosFinal[i].numCodigo + 
                        '\n                                                                  Descripcion.: ' + this.productosFinal[i].strNombre +  
                        '\n                                                                  Cantidad.: ' + this.cantidad(this.productosFinal[i]) + 
                        '\n                                                                  Precio Catalogo.: ' + Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(this.productosFinal[i].precioCatalogo)
      }
      prods = prods + '\n                                                                                               // Total Pedido: ' + Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(this.totalPedido)
      //console.log(prods)
      window.open('https://api.whatsapp.com/send/?text=' + prods)
    }
  },
  computed: {
    ...mapState(["productosShopping","productosFinal","productosFinal","campaña"]),
    totalPedido(){
      let suma = 0
      this.productosShopping.forEach((element) => {
        suma = suma + element.precioCatalogo
      })

      return suma
    }
  }
};
</script>
<style scoped>
  .cont_main{
    position: fixed;
    display: block;
    background: white;
    height: 90%;
    width: 25rem;
    margin-top: 4rem;
    box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.5);
    border-radius: 2rem 0 0 2rem;
    padding: 1rem;
    z-index: 40;
    transition: .3s ease-in-out;
    overflow: hidden;
  }
  .cont_main span{
    position: relative;
    display: table;
    margin: 0 auto 1rem auto;
  }
  .list_prods{
    position: relative;
    display: block;
    background: rgba(0, 0, 0, 0.1);
    box-shadow: inset 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 60%;
    padding: 0.1rem 1rem;
    border-radius: 2rem;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .list_prods::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    transition: 0.5s ease-in-out;
    scroll-behavior: smooth;
  }
  .list_prods::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: 10px;
  }
  .list_prods::-webkit-scrollbar-track {
    background: transparent;
  }
  .cont_total{
    position: relative;
    background: white;
    height: auto;
    width: 100%;
    margin: 2rem 0;
    box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.5);
    border-radius: 2rem ;
    padding: 1rem;
  }
  .cont_btnWhatsapp{
    position: relative;
    background: rgb(37, 211, 102);
    height: auto;
    width: 100%;
    margin: 2rem 0;
    box-shadow: 0rem 0rem 1rem 0rem rgba(37, 211, 102, 1);
    border-radius: 2rem;
    padding: 1rem;
  }
  .cont_vacio label {
    position: relative;
    display: block;
    text-align: center;
    padding: 2rem;
  }
  .cont_prod{
    position: relative;
    background: white;
    height: auto;
    width: 100%;
    margin: 0.5rem 0;
    box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.5);
    border-radius: 2rem;
    padding: 1rem;
  }
  .cont_prod div, span{
    position: relative;
    display: inline-block;
    width: 100%;
    margin: none !important;
    text-align: center;
  }
  .cont_precios div, .cont_btn{
    display: grid !important;
  }
  .cont_btn div{
    position: relative !important;
    display: block !important;
    border-radius: 100%;
    height: 30px !important;
    width: 30px !important;
    padding: 3px;
    cursor: pointer;
    left: 0.5rem;
    top: 30%;
  }
  .eliminar_prod{
    background: rgb(167, 0, 0);
    box-shadow: 0.1rem 0.1rem 0.3rem 0.1rem rgba(167, 0, 0, 0.5);
  }
  .sumar_cant{
    background: rgb(14, 167, 0);
    box-shadow: 0.1rem 0.1rem 0.3rem 0.1rem rgba(14, 167, 0, 0.5);
  }
  .restar_cant{
    background: rgb(249, 58, 90);
    box-shadow: 0.1rem 0.1rem 0.3rem 0.1rem rgba(249, 58, 90, 0.5);
  }
</style>
